module.exports = "import UniformUI\n"